export const apiUrl = "https://api.fluencycompass.com";
export const socketUrl = "https://api.fluencycompass.com";

// export const apiUrl = "https://ae25-202-47-38-117.ngrok-free.app";
// export const socketUrl = "https://ae25-202-47-38-117.ngrok-free.app";

export const s3Url = "https://d38ymokpdtleo7.cloudfront.net";
export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

// Public marketing site — hosts the CMS-managed policy pages the signup form
// links out to.
export const websiteUrl = "https://fluencycompass.com";
export const privacyPolicyUrl = `${websiteUrl}/privacy-policy`;
export const termsAndConditionsUrl = `${websiteUrl}/terms-and-conditions`;
